import Stack from '@mui/material/Stack';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { blue } from '@material-ui/core/colors/';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import products from '../../data/computer'
import { useHistory } from "react-router-dom";

const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: blue[600],
  '&:hover': {
    backgroundColor: blue[900],
  },
}));

var dateNow= new Date().getTime()
var timestamp = dateNow + (30 * 24 * 60 * 60 * 1000)
let arrayTrue = []

let dataValidation = products.map((row) => (
  //Se data de vencimento do produto é menor ou igual a 30 dias contando com o dia de hoje 
  (new Date(Date.parse(row.expirate)).getTime())<=timestamp)&&(new Date(Date.parse(row.expirate)).getTime())>dateNow?
  row.licenca :
  null
)
dataValidation.map((a, i) => (
  a != null ?
    arrayTrue[i] = a :
    ''
))
const result = arrayTrue.filter(e => e);

export default function CustomizedButtonsExpirando() {
  const history = useHistory();

  const routeChange = () =>{ 
    let path = '/expiring-license' 
    history.push(path);
  }
  return (
    <Stack spacing={2} direction="row">
      <ColorButton
        style={{  minWidth: '100%', minHeight: '3.5rem' }}
        startIcon={<WarningAmberIcon></WarningAmberIcon>}
        onClick={routeChange}
        size="larger" variant="contained">Licenças expirando (30 dias): {result.length}
      </ColorButton>
    </Stack>
  );
}